import type { SimulationLaunchMetricRecordsByName } from "./types"

export function getSelectedMetricIds(
  enabledMetrics: string[],
  metricRecords: SimulationLaunchMetricRecordsByName,
): string[] | null {
  const metricIds: string[] = []
  for (const metricName of enabledMetrics) {
    const metricId = metricRecords[metricName]?.id
    if (!metricId) {
      return null
    }
    metricIds.push(metricId)
  }
  return metricIds
}
